const AppraisalPDP = () => {
	return `mutation ManagerAppraisal(
		$appraisee_id: String
		$pdps: [PDPAppraisalInput]
	) {
		managerAppraisal(
			appraisee_id: $appraisee_id
			pdps: $pdps
		)
	}`;
}

export default AppraisalPDP;
